import React from 'react';
import { createRoot } from 'react-dom/client';
import { GasQueryProvider, GasToastProvider, GasConfirmProvider } from '../../shared/kit';
import App from './App';
import type { ShopSearchCatalogInitData } from './types';
import './style.css';

const MOUNT_ID = 'gas-shop-search-catalog-app';

const mountEl = document.getElementById(MOUNT_ID);

if (mountEl?.dataset.reactInit && mountEl.isConnected) {
    let initData: ShopSearchCatalogInitData = {};

    try {
        initData = JSON.parse(mountEl.dataset.reactInit) as ShopSearchCatalogInitData;
    } catch (error) {
        if (window.console?.error) {
            window.console.error('[gas-shop-search-catalog] init JSON invalide', error);
        }
    }

    try {
        createRoot(mountEl).render(
            <React.StrictMode>
                <GasQueryProvider>
                    <GasToastProvider>
                        <GasConfirmProvider>
                            <App initData={initData} />
                        </GasConfirmProvider>
                    </GasToastProvider>
                </GasQueryProvider>
            </React.StrictMode>,
        );
    } catch (error) {
        if (window.console?.error) {
            window.console.error('[gas-shop-search-catalog] mount KO', error);
        }
    }
}
